module.exports = __webpack_public_path__ + "img/43.6.CODm.fcfad708.png";